module.exports = __webpack_public_path__ + "static/media/arrow.56d46fde.svg";